<script setup lang="ts">
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
    assetId?: string;
}

const { sale, assetId } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const { isBundleMono } = useSaleType(() => sale.type);

// DATA
const sortedAssets = computed(() => sortSaleAssets(sale));
const asset = computed(() => (assetId ? sale.assets.find(_a => _a.id === assetId)! : sale.mainAsset));

const hasDetails = computed<boolean>(() =>
    isBundleMono.value ? sale.assets.some(_a => _a.images.damage.length) : !!asset.value.images.damage.length
);
</script>

<template>
    <section v-if="hasDetails" class="flex flex-col gap-6">
        <h2 class="text-highlighted text-2xl font-semibold md:text-3xl">{{ tt('sdp.detailsTitle', isBundleMono ? 2 : 1) }}</h2>

        <template v-if="isBundleMono">
            <template v-for="(_asset, index) in sortedAssets" :key="_asset.id">
                <BaseAccordion
                    v-if="!!_asset.images.damage.length"
                    size="md"
                    :items="[{ label: tt('asset.vehicleIndex', { index: index + 1 }) }]"
                    default-open
                >
                    <template #content>
                        <SdpDetailsItem :asset="_asset" :index="index + 1" />
                    </template>
                </BaseAccordion>
            </template>
        </template>

        <SdpDetailsItem v-else :key="asset.id" :asset="asset" />
    </section>
</template>
